import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import FroalaEditor from "react-froala-wysiwyg";
import Froalaeditor from "froala-editor";
import { Editor } from "slate";
import { useTranslation } from "react-i18next";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import EditReportIcon from "../../../../components/SVGComponents/EditReportIcon";
import GPTMicIcon from "../../../../components/SVGComponents/GPTMicIcon";
import { Toggle } from "@fluentui/react/lib/Toggle";
import { isLLMAgentPresent } from "../../../../service/MaskImageService";
import {
  ContextualMenu,
  DefaultButton,
  mergeStyles,
  Pivot,
  PivotItem,
  PrimaryButton,
  TextField,
} from "@fluentui/react";
import ModalMain from "../../../../components/Modal/ModalMain";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import {
  BackgroundColorIcon,
  PreviewIcon,
  RefreshIcon,
} from "@fluentui/react-icons-mdl2";
import {
  NONXRAYMODALITIES,
  SHOW_NOT_ORIGNAL_MODALITY_LIST,
  USERTYPES,
} from "../../../../constants/Constants";
import DownloadIcon from "../../../../components/SVGComponents/DownloadIcon";
import UploadIcon from "../../../../components/SVGComponents/UploadIcon";
import EyeIcon from "../../../../components/SVGComponents/EyeIcon";
import RowBadge from "../../../StudyList/components/Badge/RowBadge";
import { getReportTemplatesData } from "../../../../service/StudyReportService";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import themeContext from "../../../../context/theme/ThemeContext";
// import Observations from "../SmartReporting/Observations";
import FormatterAgentModal from "../../../StudyList/components/Modal/FormatterAgent/FormatterAgentModal";
import userContext from "../../../../context/users/UserContext";
import { isMobile } from "react-device-detect";
import { use } from "react";
import AgenticReportingContext from "../../../../context/agentic-reporting/AgenticReportingContext";
import { getEnv } from '../../../../helpers/EnvHelper';
import CapturedImagesTab from "./CapturedImagesTab";

const CustomEditor = (props) => {
  const { getThemeColor } = useContext(themeContext);
  const froalaInstanceRef = useRef(null);
  const isVerticalMonitor = window.innerWidth <= 1200;
  const computeBaseHeight = useCallback(() => {
    const offset = SHOW_NOT_ORIGNAL_MODALITY_LIST.includes(props.modality)
      ? (isVerticalMonitor ? 200 : 150)
      : props.showPathologyOptions
        ? (isVerticalMonitor ? 265 : 215)
        : (isVerticalMonitor ? 200 : 150);

    return window.innerHeight - offset;
  }, [props.modality, props.showPathologyOptions, isVerticalMonitor]);
  const [containerHeight, setContainerHeight] = useState(computeBaseHeight());

  // When opened from study list (external reporting), use the explicit editor height from parent
  const effectiveHeight = props.isStudyList && props.editorHeight 
    ? (parseInt(props.editorHeight, 10) || containerHeight) 
    : containerHeight;

  let isVdcPlatform = (getEnv("REACT_APP_VDC_PLATFORM")=="true"||getEnv("REACT_APP_VDC_PLATFORM")==true)?true:false;
 // Update height on resize
  useEffect(() => {
    const updateHeight = () => {
      const newHeight = computeBaseHeight();
      setContainerHeight(newHeight);
      if (froalaInstanceRef.current) {
        const newEffective = props.isStudyList && props.editorHeight
          ? (parseInt(props.editorHeight, 10) || newHeight)
          : newHeight;
        froalaInstanceRef.current.setHeight(newEffective);
      }
    };

    window.addEventListener("resize", updateHeight);
    updateHeight();

    return () => window.removeEventListener("resize", updateHeight);
  }, [computeBaseHeight]);

  const [t, i18n] = useTranslation();
  const [editReport, setEditReport] = useState(true);
  const [disableCopyPaste, setDisableCopyPaste] = useState(true);
  const [showMobileMoreMenu, setShowMobileMoreMenu] = useState(false);
  const mobileMoreMenuRef = useRef(null);

  const [editorReady, setEditorReady] = useState(false);
  // showCapturedImagesModal / setShowCapturedImagesModal now come from studyReportContext so the
  // agentic LLMTopBar toolbar can open this same popup (see destructure above).
  const { themeName } = useContext(themeContext);

  const { userId, privilegedFirmDoctor, enableLlmReport } =
    useContext(userContext);

  const {
    refreshReport,
    patientReports,
    activeTab,
    setActiveTab,
    disableAddendumTab,
    addendumModel,
    setAddendumModel,
    showFistolugram,
    //  (Fistulogram Modal): single button opens the unified annotation modal
    setOpenFistolugramModal,
    fistolugramFilePath,
    // (Fibroid Modal): parallel button, opens the fibroid annotation modal
    showFibroid,
    setOpenFibroidModal,
    fibroidFilePath,
    setAlertSuccessModal,
    alertSuccessModal,
    isClientReportExist,
    showQCReasonBadge,
    setOpenQcReasonModal,
    allReportTemplates,
    isChildStudyReportState,
    showMsWord,
    isWordFilePath,
    userRole,
    allowCopyPaste,
    isRestrictionsEnabled,
    // disableObservations,
    editorRef,
    openReportModal,
    fetchS10Report,
    showFormatterPopup,
    setShowFormatterPopup,
    isReportContentChanged,
    isAdvanceViewer,
    studyDescription,
    reportDoneStatusState,
    isNormalStudy,
    useOldReportTemplate,
    isWidget,
    studyReportPdfSelected,
    studyReportPdfUrl,
    activeTabKey,
    disableEditReport,
    removeCapturedImageFromReport,
    hasNewCapturedImage,
    setHasNewCapturedImage,
    newCapturedImageCount,
    setNewCapturedImageCount,
    showCapturedImagesModal,
    setShowCapturedImagesModal,
  } = useContext(studyReportContext);

  const {
    isFirstCall,
    reportFromAPI,
    setDisableCopyButton,
    isAgenticTab,
    getChatInputRef,
    hasTextChanged,
  } = useContext(AgenticReportingContext);

  useEffect(() => {
    let ele = document.getElementsByClassName("fr-toolbar");
    if (ele[0] != undefined) {
      if (ele[0].style != undefined) {
        // console.log(ele[0].style);
        ele[0].style.display = "none";
      }
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (editReport) {
        let ele = document.getElementsByClassName("fr-toolbar");
        if (ele[0] != undefined) {
          if (ele[0].style != undefined) {
            // console.log(ele[0].style);
            ele[0].style.display = "";
          }
        }
      } else {
        let ele = document.getElementsByClassName("fr-toolbar");
        if (ele[0] != undefined) {
          if (ele[0].style != undefined) {
            // console.log(ele[0].style);
            ele[0].style.display = "none";
          }
        }
      }
    }, 500);
  }, [editReport]);

  const {
    model,
    setModel,
    childModel,
    childPatientReports,
    childCurrentActiveTab,
    handleModelChange,
    firstReportAdded,
    setFirstReportAdded,
    selectedCategoryTemplate,
    studyId,
    currentActiveTab,
    reviewerId,
    reviewStatus,
  } = useContext(studyReportContext);

  const { s10User, s10Url, formatterAgentEnabled } =
    useContext(studyReportContext);

  useEffect(() => {
    if (firstReportAdded == true && disableEditReport === false) {
      setTimeout(() => {
        setEditReport(true);
      }, 100);
    }
  }, [firstReportAdded,disableEditReport]);

  // Disable editing when disableEditReport is true
  useEffect(() => {
    if (disableEditReport === true) {
      setEditReport(false);
    } else if (disableEditReport === false && firstReportAdded === true) {
      setEditReport(true);
    }
  }, [disableEditReport, firstReportAdded]);

  // //Disable editing in mobile read-only mode
  // useEffect(()=>{
  //   if(props.readOnly && isMobile){
  //     setEditReport(false);
  //   }
  // },[props.readOnly,isMobile]);
  useEffect(() => {
    if (patientReports.length == 0) {
      setFirstReportAdded(false);
      setEditReport(true);
    }
  }, [patientReports]);

  // Note: capturing an image no longer auto-opens the popup. Instead the count of
  // newly captured images is shown as a badge on the captured-images button, and the
  // user opens the popup themselves (which clears the count).

  const checkForClientReport = async () => {
    let studyId = window.location.pathname.substring(
      window.location.pathname.lastIndexOf("/") + 1,
    );
    console.log("--- Study Id ---", studyId);
    const ret = await getReportTemplatesData(studyId);
    if (ret.status === 200) {
      if (ret.data.data?.clientReportTemplates?.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  };

  const hasText = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;

    const normalize = (str) => str.replace(/\s+/g, " ").trim();
    const actual = normalize(tmp.textContent);
    return !!actual;
  };

  const contentHasNotChanged = useMemo(() => {
    const apiContentMatches = !hasTextChanged(reportFromAPI, model);

    let templateContentMatches = false;
    try {
      let currentMentionInChat = null;
      const currentChatEditor = getChatInputRef
        ? getChatInputRef(activeTabKey)
        : null;

      if (currentChatEditor) {
        const [mentionEntry] = Editor.nodes(currentChatEditor, {
          at: [],
          match: (n) => n.type === "mention",
        });
        if (mentionEntry) {
          const [node] = mentionEntry;
          currentMentionInChat = { label: node.character, value: node.value };
        }
      }

      if (currentMentionInChat && allReportTemplates?.agenticReportTemplates) {
        const matchingTemplate = allReportTemplates.agenticReportTemplates.find(
          (item) =>
            item.agenticReportTemplateDto?.title === currentMentionInChat.label,
        );
        const reportTemplateContent = matchingTemplate
          ? matchingTemplate.agenticReportTemplateDto.template
          : null;

        if (reportTemplateContent === null) {
          templateContentMatches = !hasTextChanged("", model);
        } else {
          templateContentMatches = !hasTextChanged(
            reportTemplateContent,
            model,
          );
        }
      }
    } catch (e) {
      console.error("Error calculating watermark template match:", e);
    }
    return apiContentMatches || templateContentMatches;
  }, [
    model,
    reportFromAPI,
    hasTextChanged,
    allReportTemplates,
    getChatInputRef,
    activeTabKey,
  ]);

  const showWatermark =
    !isNormalStudy &&
    isFirstCall &&
    isAgenticTab &&
    reportDoneStatusState === 0 &&
    contentHasNotChanged &&
    hasText(model);

  const appendStyle = (el, newStyles) => {
    const existing = el.getAttribute("style") || "";
    const styleMap = {};

    // Convert existing styles to map
    existing.split(";").forEach((s) => {
      const [key, value] = s.split(":").map((x) => x?.trim());
      if (key && value) styleMap[key] = value;
    });

    // Add/override with new styles
    Object.entries(newStyles).forEach(([key, value]) => {
      styleMap[key] = value;
    });

    // Reconstruct and apply
    const finalStyle = Object.entries(styleMap)
      .map(([k, v]) => `${k}: ${v}`)
      .join("; ");
    el.setAttribute("style", finalStyle);
  };

  const config = {
    placeholderText: "Your Report Will Come Here!",
    key: getEnv("REACT_APP_FROALA_API_KEY"),
    attribution: false,
    charCounterCount: false,
    ...(useOldReportTemplate ? { enter: FroalaEditor.ENTER_BR } : {}),
    // enter: FroalaEditor.ENTER_BR,
    // height: containerHeight,
    height:
      enableLlmReport && isLLMAgentPresent(props.modality, studyDescription)
        ? (disableEditReport ? "100%" : `calc(100% - 52px)`)
        : effectiveHeight,
    toolbarSticky: false,
    width: 818,
    fontSize: [
      "8",
      "9",
      "10",
      "10.67",
      "11",
      "12",
      "13",
      "13.33",
      "14",
      "14.67",
      "15",
      "16",
      "17",
      "17.33",
      "18",
      "18.67",
      "19",
      "21.33",
      "24",
      "30",
      "36",
      "48",
      "60",
      "72",
      "96",
    ],
    fontSizeDefault: "12",
    fontSizeUnit: "px",
    lineHeights: {
      Default: "1.5",
      Single: "1",
      1.15: "1.15",
      1.5: "1.5",
      Double: "2",
    },
    fontFamilyDefaultSelection: isVdcPlatform ? "Verdana, sans-serif" : "Times New Roman, serif", 
    paste: false, // Disable paste functionality
    pastePlain: false,
    pasteAllowedStyleProps: [],
    wordPasteModal: false,
    pluginsEnabled: [
      "fullscreen",
      "codeBeautifier",
      "colors",
      "fontFamily",
      "lineHeight",
      "fontSize",
      "paragraphFormat",
      "paragraphStyle",
      "align",
      "lists",
      "table",
      "wordPaste",
      "image",
      "pageBreak",
    ],
    imageUpload: false,
    imagePaste: false,
    imageResizeWithPercent: true,
    imageRoundPercent: true,
    imageDefaultAlign: "center",
    imageDefaultDisplay: "block",
    imageEditButtons: [
      "imageAlign",
      "imageCaption",
      "imageRemove",
      "|",
      "imageReplace",
      "imageAlt",
      "imageSize",
      "imageStyle",
      "|",
      "pageBreakBeforeImage",
      "pageBreakAfterImage",
    ],
    toolbarButtons: {
      moreText: {
        buttons: [
          "undo",
          "redo",
          "|",
          "paragraphFormat",
          "lineHeight",
          "|",
          "fontFamily",
          "|",
          "fontSize",
          "|",
          "bold",
          "italic",
          "underline",
          "|",
          "fullscreen",
          "|",
          "formatOL",
          "formatUL",
          "strikeThrough",
          "clearFormatting",
          "|",
          "textColor",
          "backgroundColor",
          "|",
          "alignLeft",
          "alignCenter",
          "alignRight",
          "alignJustify",
          // 'inlineClass',
          // 'inlineStyle',
          "outdent",
          "indent",
          "|",
          "insertTable",
          "|",
          "pageBreak",
          "|",
          "copy",
        ],
        align: "left",
        buttonsVisible: 11,
      },
    },
    /*lineHeights: {
      1.15: "1.15",
      1.5: "1.5",
      Double: "2",
    },*/
    events: {
      "paste.before": function (e) {
        // console.log("---checkForClientReport----");
        // const localCheck = checkForClientReport();
        console.log(
          "IsClientReportExist",
          isClientReportExist,
          allReportTemplates,
        );
        if (
          (isRestrictionsEnabled &&
            (isClientReportExist ||
              allReportTemplates?.clientReportTemplates?.length > 0) &&
            !allowCopyPaste) ||
          getEnv("REACT_APP_PROTECTED_MODE") == "true"
        ) {
          console.log("--- Blocking copy paste ----");
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.description = t("string-literals.copy-paste-disabled");
            return newItem;
          });
          return false;
        } else {
          return true;
        }
      },
      "paste.afterCleanup": function (html) {
        // Regex to replace only border-related windowtext
        return html.replace(
          /(border(?:-(top|right|bottom|left))?:[^;]*?)windowtext/gi,
          "$1black",
        );
      },
      "table.inserted": function (tableEl) {
        if (tableEl.dataset.capturedTable) return;
        appendStyle(tableEl, {
          "border-collapse": "collapse",
          border: "1px solid black",
        });

        const cells = tableEl.querySelectorAll("td, th");
        cells.forEach((cell) => {
          appendStyle(cell, {
            border: "1px solid black",
            "padding-left": "6px",
            "padding-right": "6px",
          });
        });
      },
      "image.removed": function ($img) {
        const capturedId = $img.attr("data-captured-id");
        if (capturedId) {
          removeCapturedImageFromReport(Number(capturedId));
        }
      },
      "keydown": function (e) {
        if ((e.ctrlKey || e.metaKey) && e.key === "Enter") {
          e.preventDefault();
          try {
            if (this.commands && typeof this.commands.exec === "function") {
              this.commands.exec("pageBreak");
            } else if (this.pageBreak && typeof this.pageBreak.insert === "function") {
              this.pageBreak.insert();
            }
          } catch (err) {
            console.error("Page break insert failed:", err);
          }
          return false;
        }
      },
    },
  };

  const handleInsertPageBreak = () => {
    const editor = editorRef?.current?.editor;
    if (!editor) return;
    try {
      editor.selection.restore();
      if (editor.commands && typeof editor.commands.exec === "function") {
        editor.commands.exec("pageBreak");
      } else if (editor.pageBreak && typeof editor.pageBreak.insert === "function") {
        editor.pageBreak.insert();
      }
    } catch (err) {
      console.error("Page break insert failed:", err);
    }
  };

  // useEffect(() => {
  //     // Access the Froala Editor instance through the ref
  //     if(editorRef.current != null){
  //         const editorInstance = editorRef.current.editor;
  //         console.log("hello",activeTab);
  //         // Set the default font size for the editor content
  //         editorInstance.$el.css('font-size', '11px');

  //         const parentDiv = document.querySelector('.fr-element.fr-view');

  //         const childDiv = parentDiv.firstChild;

  //         childDiv.style.fontSize = '11px';
  //     }

  //   }, [activeTab,editorRef]);

  useEffect(() => {
    if (editorRef !== null && editorReady) {
      const editorInstance = editorRef.editor;

      const disableCopyPaste = (e) => {
        // Check if the key combination is for copy (Ctrl + C) or paste (Ctrl + V)
        if (
          (e.ctrlKey || e.metaKey) &&
          (e.key === "c" || e.key === "C" || e.key === "v" || e.key === "V")
        ) {
          console.log("Calling");
          e.preventDefault();
          return false;
        }
      };

      editorInstance.events.on("keydown", disableCopyPaste);

      // Disable copy-paste through toolbar buttons
      const disableToolbarButtons = (e) => {
        const command = e.command || e;

        if (command === "copy" || command === "paste") {
          e.preventDefault();
          return false;
        }
      };

      editorInstance.events.on("beforeCommand", disableToolbarButtons);
    }
  }, [editorRef, editorReady]);

  const emptyConfig = {
    placeholderText: "Add report first to submit",
    key: getEnv("REACT_APP_FROALA_API_KEY"),
    toolbarSticky: false,
    attribution: false,
    ...(useOldReportTemplate
      ? {
          enter:
            FroalaEditor.ENTER_BR /* replace ENTER_P with the correct constant if needed */,
        }
      : {}),
    charCounterCount: false,
    height: effectiveHeight,
    width: 800,
    events: {
      initialized() {
        // setTimeout is because there is a bug in v3 that
        // calls initialized before editor has finished initializing
        setTimeout(() => {
          this.edit.off();
        });
      },
    },
  };

  const readOnlyConfig = {
    placeholderText: "Your Report Will Come Here!",
    key: getEnv("REACT_APP_FROALA_API_KEY"),
    attribution: false,
    charCounterCount: false,
    ...(useOldReportTemplate ? { enter: FroalaEditor.ENTER_BR } : {}),
    height: enableLlmReport && isLLMAgentPresent(props.modality, studyDescription) ? (disableEditReport ? "100%" : `calc(100% - 52px)`) : effectiveHeight,
    toolbarSticky: false,
    width: 818,
    fontSize: [
      "8", "9", "10", "10.67", "11", "12", "13", "13.33", "14", "14.67", "15", "16", "17", "17.33", "18", "18.67", "19", "21.33", "24", "30", "36", "48", "60", "72", "96",
    ],
    fontSizeDefault: "12",
    fontSizeUnit: "px",
    lineHeights: {
      Default: "1.5",
      Single: "1",
      1.15: "1.15",
      1.5: "1.5",
      Double: "2",
    },
    fontFamilyDefaultSelection: "Times New Roman, serif",
    pluginsEnabled: [
      "fullscreen",
      "codeBeautifier",
      "colors",
      "fontFamily",
      "lineHeight",
      "fontSize",
      "paragraphFormat",
      "paragraphStyle",
      "align",
      "lists",
      "table",
    ],
    toolbarButtons: {},
    events: {
      initialized() {
        setTimeout(() => {
          this.edit.off();
        });
      },
    },
  };

  let msWordConfig = {
    placeholderText: "",
    key: getEnv("REACT_APP_FROALA_API_KEY"),
    attribution: false,
    toolbarSticky: false,
    height: effectiveHeight,
    width: 800,
    events: {
      initialized() {
        // setTimeout is because there is a bug in v3 that
        // calls initialized before editor has finished initializing
        setTimeout(() => {
          this.edit.off();
        });
      },
    },
  };
  Froalaeditor.DefineIcon("copy", { NAME: "insert", SVG_KEY: "add" });
  Froalaeditor.RegisterCommand("copy", {
    title: "Copy",
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () {
      var html = this.html.get();
      var div = document.createElement("div");
      div.innerHTML = html;
      // console.log(div.innerText);
      var textField = document.createElement("textarea");
      // console.log(div.innerHTML);
      textField.innerHTML = html;
      // console.log(textField);
      textField.select();
      document.execCommand("selectall", null, false);
      document.execCommand("copy");
      // console.log(html);
      if (html != "") {
      }

      textField.remove();
    },
  });

  const FR_PAGE_BREAK_HTML =
    '<div class="fr-page-break" contenteditable="false"><span style="display:none;">\u200B</span><div></div><span style="display:none;">\u200B</span></div>';

  const insertPageBreakAroundImage = function (editor, position) {
    const $img = editor.image.get();
    if (!$img || !$img[0]) return;
    const img = $img[0];
    const container = img.closest("p") || img;
    const parent = container.parentNode;
    if (!parent) return;
    if (position === "before") {
      container.insertAdjacentHTML("beforebegin", FR_PAGE_BREAK_HTML);
    } else {
      container.insertAdjacentHTML("afterend", FR_PAGE_BREAK_HTML);
    }
    if (editor.undo && typeof editor.undo.saveStep === "function") {
      editor.undo.saveStep();
    }
    if (editor.events && typeof editor.events.trigger === "function") {
      editor.events.trigger("contentChanged");
    }
  };

  Froalaeditor.DefineIcon("pageBreakBeforeImage", {
    NAME: "PB↑",
    template: "text",
  });
  Froalaeditor.RegisterCommand("pageBreakBeforeImage", {
    title: "Page break before image",
    focus: false,
    undo: true,
    refreshAfterCallback: false,
    callback: function () {
      insertPageBreakAroundImage(this, "before");
    },
  });

  Froalaeditor.DefineIcon("pageBreakAfterImage", {
    NAME: "PB↓",
    template: "text",
  });
  Froalaeditor.RegisterCommand("pageBreakAfterImage", {
    title: "Page break after image",
    focus: false,
    undo: true,
    refreshAfterCallback: false,
    callback: function () {
      insertPageBreakAroundImage(this, "after");
    },
  });

  useEffect(() => {
    if (openReportModal) {
      setModel("");
    }
  }, [openReportModal]);

  useEffect(() => {
    let temp = activeTab;
    setActiveTab(temp);
  }, [firstReportAdded]);

  // useEffect(() => {
  //   // console.log(activeTab);
  //   if (activeTab == 1) {
  //     let ele = document.getElementsByClassName("custom-tab");
  //     if (!ele[0].classList.contains("custom-tab-line"))
  //       ele[0].classList.add("custom-tab-line");
  //     if (ele[1].classList.contains("custom-tab-line"))
  //       ele[1].classList.remove("custom-tab-line");
  //   }
  //   if (activeTab == 2) {
  //     let ele = document.getElementsByClassName("custom-tab");
  //     if (!ele[1].classList.contains("custom-tab-line"))
  //       ele[1].classList.add("custom-tab-line");
  //     if (ele[0].classList.contains("custom-tab-line"))
  //       ele[0].classList.remove("custom-tab-line");
  //   }
  //   // let ele = document.getElementsByClassName("fr-toolbar");
  //   // if(ele[0] != undefined){
  //   //     if(ele[0].style != undefined){
  //   //         console.log(ele[0].style);
  //   //         ele[0].style.display = "";
  //   //     }
  //   // }
  //   // console.log(ele);
  // }, [activeTab]);

  useEffect(() => {
    if (props.isChild != null && props.isChild != undefined) {
      const frWrapper = document.querySelector(".fr-wrapper");
      if (frWrapper) {
        if (props.isChild) {
          frWrapper.style.background = "#c5c5c5";
        } else {
          frWrapper.style.background = "#FFF";
        }
      }
    }
  }, [props.isChild, childModel, document.querySelector(".fr-wrapper")]);

  return (
    <div
      // className="new-editor-section"
      // className={`new-editor-section ${(enableLlmReport && isLLMAgentPresent(props.modality, studyDescription )) ? 'llm-editor-enabled' : ''}`}
      className={`new-editor-section 
        ${enableLlmReport && isLLMAgentPresent(props.modality, studyDescription) ? "llm-editor-enabled" : ""} 
        ${showWatermark ? "editor-container-watermark" : ""}`}
      style={{
        margin:
          enableLlmReport && isLLMAgentPresent(props.modality, studyDescription)
            ? isWidget
              ? "0 0.3% 0"
              : "0 1.3% 0"
            : 0,
        position: "relative",
        height: "100%",
        boxSizing: "border-box",
        colorScheme: `${themeName === "light" ? "none" : "inherit"}`,
      }}
    >
      {studyReportPdfSelected && (
        <iframe
          // key={studyReportPdfUrl}   // forces reload
          // src={studyReportPdfUrl}
          src={`${studyReportPdfUrl}#toolbar=0&navpanes=0&scrollbar=0`} //to hide toolbar, side panel and scrollbar 
          title="Study Report PDF"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      )} 

      {!studyReportPdfSelected && (<>

      {!(enableLlmReport && isLLMAgentPresent(props.modality, studyDescription )) && isWordFilePath && (
        <div id="wordMessageContainer" className="word-message-container">
          <span>
            {userRole == USERTYPES.FIRMADMIN || userRole == USERTYPES.ADMIN || privilegedFirmDoctor
              ? t("string-literals.disable-editor-for-msword-admin") : userRole == USERTYPES.RADIOLOGIST && reviewerId && reviewerId == userId && reviewStatus != 1
              ? t("string-literals.disable-editor-for-msword-reviewer") 
              : t("string-literals.disable-editor-for-msword-non-admin")}
          </span>
        </div>
      )}

      {!(
        enableLlmReport && isLLMAgentPresent(props.modality, studyDescription)
      ) && (
        <div className="tab-add-refresh-section">
          <div className="edit-report-icon">
            {!props.readOnly && activeTab != 3 && (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setEditReport((prev) => !prev);
                }}
              >
                <EditReportIcon active={editReport} />
              </span>
            )}

            <div style={{ marginLeft: "10px", cursor: "not-allowed" }}>
              {/* <GPTMicIcon/> */}
            </div>
          </div>

          {/* TODO */}
          {selectedCategoryTemplate !== "dsrTemplate" ? (
            <div className="custom-tab-section">
              <button
                className={`custom-tab ${activeTab === 1 ? "custom-tab-line" : ""}`}
                onClick={() => {
                  setEditReport(true);
                  // if(!(isMobile && props.readOnly)){
                  //   setEditReport(true);
                  // }
                  setActiveTab(1);
                }}
              >
                <span
                  style={{ color: getThemeColor("primary-color") }}
                  className="custom-tab-text"
                >
                  Final Report
                </span>
              </button>
              <button
                style={{
                  cursor: disableAddendumTab ? "not-allowed" : "pointer",
                }}
                className={`custom-tab ${activeTab === 2 ? "custom-tab-line" : ""}`}
                onClick={() => {
                  setEditReport(true);
                  // if(!(isMobile && props.readOnly)){
                  //   setEditReport(true);
                  // }
                  setActiveTab(2);
                }}
                disabled={disableAddendumTab}
              >
                <span
                  style={{ color: getThemeColor("primary-color") }}
                  className="custom-tab-text"
                >
                  Addendum
                </span>
              </button>
            </div>
          ) : (
            <div className="custom-tab-section">
              {/* <button
            style={{ cursor: disableObservations ? "not-allowed" : "pointer" }}
            className={`custom-tab ${activeTab === 3 ? "custom-tab-line" : ""}`}
            onClick={() => {
              setEditReport(true);
              // if(!(isMobile && props.readOnly)){
              //   setEditReport(true);
              // }
              setActiveTab(3);
            }}
            disabled={disableObservations}
          >
            <span
              style={{ color: getThemeColor("primary-color") }}
              className="custom-tab-text"
            >
              Observations
            </span>
          </button> */}
              <button
                style={{ cursor: "pointer" }}
                className={`custom-tab ${activeTab === 1 ? "custom-tab-line" : ""}`}
                onClick={() => {
                  setEditReport(true);
                  // if(!(isMobile && props.readOnly)){
                  //   setEditReport(true);
                  // }
                  setActiveTab(1);
                }}
                // disabled={disableAddendumTab}
              >
                <span
                  style={{ color: getThemeColor("primary-color") }}
                  className="custom-tab-text"
                >
                  Final Report
                </span>
              </button>
            </div>
          )}

          {/* OLD (Fistulogram — 3 separate icon buttons): commented out, replaced by single Fistulogram button below */}
          {/* {!(isMobile && props.readOnly) &&
            !props.isChild &&
            showFistolugram && (
              <div
                className="fistolugram-section"
                onClick={(e) => { e.stopPropagation(); }}
              >
                <span className="viewer-fistolugram-text">
                  <RowBadge tooltipText="Fistolugram" name="FIS..." />{" "}
                </span>
                <div className="fistolugram-actions">
                  <CustomToolTipHost content={t("button.download")}>
                    <span
                      onClick={() => downloadFistolugram(false)}
                      style={{ display: "flex", alignItems: "center", marginRight: "10px", cursor: "pointer" }}
                    >
                      <DownloadIcon />
                    </span>
                  </CustomToolTipHost>
                  <CustomToolTipHost content={t("button.upload")}>
                    <span
                      onClick={() => setFistolugramUploadModal(true)}
                      style={{ display: "flex", alignItems: "center", marginRight: "10px", cursor: "pointer" }}
                    >
                      <UploadIcon />
                    </span>
                  </CustomToolTipHost>
                  <CustomToolTipHost content={t("button.preview")}>
                    <span
                      onClick={() => {
                        fistolugramFilePath != null || fistolugramFilePath != "null"
                          ? downloadFistolugram(true)
                          : console.log("No Fistolugram");
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: fistolugramFilePath == null || fistolugramFilePath == "null" ? "not-allowed" : "pointer",
                      }}
                    >
                      <EyeIcon color={fistolugramFilePath == null || fistolugramFilePath == "null" ? "#585858" : "#C1C1C1"} />
                    </span>
                  </CustomToolTipHost>
                </div>
              </div>
            )} */}
          {!(isMobile && props.readOnly) && showQCReasonBadge && (
            <div
              onClick={(e) => { e.stopPropagation(); setOpenQcReasonModal(true); }}
              style={{ display: "flex", alignItems: "center", cursor: "pointer", marginRight: "8px" }}
            >
              <span className="viewer-fistolugram-text">
                <RowBadge tooltipText="QC Reason" name="QC R..." />{" "}
              </span>
            </div>
          )}

          <div
            onClick={() => {}}
            className="refresh-section"
            style={{ position: "relative" }}
          >
            {s10User && (
              <div className="refresh-button">
                <PrimaryButton
                  iconProps={{
                    iconName: "CloudDownload",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (!props.isChild) {
                      fetchS10Report();
                    }
                  }}
                  style={{ padding: "0px 5px", margin: "0px 5px" }}
                  text={t("button.s10-report")}
                />
                {/* <RefreshIcon />
            <span className="refresh-text">Refresh</span> */}
              </div>
            )}

          {showFormatterPopup &&
            <FormatterAgentModal/>
          }

            {(
              <div className="refresh-button captured-images-icon-btn">
                <CustomToolTipHost
                  content={t("captured-images-tab.tab-label")}
                  id="captured-images-button-tooltip"
                >
                  <PrimaryButton
                    iconProps={{ iconName: "PictureLibrary", cursor: "pointer" }}
                    onClick={() => {
                      setShowCapturedImagesModal(true);
                      if (hasNewCapturedImage) setHasNewCapturedImage(false);
                      if (newCapturedImageCount > 0) setNewCapturedImageCount(0);
                      // The popup refreshes the library itself on mount (after
                      // pulling captured-pages first), so no fetch is needed here —
                      // doing it would just duplicate the /sc-dicom/library call.
                    }}
                    className="captured-images-square-btn"
                    ariaLabel={t("captured-images-tab.tab-label")}
                  />
                </CustomToolTipHost>
                {newCapturedImageCount > 0 && (
                  <span className="captured-images-icon-count-badge">
                    {newCapturedImageCount > 99 ? "99+" : newCapturedImageCount}
                  </span>
                )}
              </div>
            )}

            {/* NEW (Fistulogram Modal): single button styled like Refresh, sitting immediately
                left of the Refresh button so the three action buttons stay grouped. The green
                dot in the top-right corner indicates that an annotated fistulogram image has
                already been saved for this study (non-null fistolugramFilePath). */}
            {!isMobile && !props.isChild && showFistolugram && (
              <div className="refresh-button keep-label" style={{ marginRight: "4px", position: "relative" }}>
                <CustomToolTipHost
                  content={fistolugramFilePath != null && fistolugramFilePath !== "null" ? "Fistulogram (edited)" : "Fistulogram"}
                  id="fistulogram-button-tooltip"
                >
                  <PrimaryButton
                    onClick={() => setOpenFistolugramModal(true)}
                    text="Fistulogram"
                    styles={{
                      root:  { padding: "0px 5px", minWidth: "60px", maxWidth: "100px" },
                      label: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" },
                    }}
                  />
                </CustomToolTipHost>
                {fistolugramFilePath != null && fistolugramFilePath !== "null" && (
                  <span
                    style={{
                      position: "absolute",
                      top: -4,
                      right: -4,
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      background: "#22c55e",
                      border: "1.5px solid #ffffff",
                      pointerEvents: "none",
                      zIndex: 1,
                    }}
                  />
                )}
              </div>
            )}
            {/* NEW (Fibroid Modal): immediately left of the Refresh button, right of Fistulogram.
                Same edited-state indicator pattern as Fistulogram above. */}
            {!isMobile && !props.isChild && showFibroid && (
              <div className="refresh-button keep-label" style={{ marginRight: "4px", position: "relative" }}>
                <CustomToolTipHost
                  content={fibroidFilePath != null && fibroidFilePath !== "null" ? "Fibroid (edited)" : "Fibroid"}
                  id="fibroid-button-tooltip"
                >
                  <PrimaryButton
                    onClick={() => setOpenFibroidModal(true)}
                    text="Fibroid"
                    styles={{
                      root:  { padding: "0px 5px", minWidth: "60px", maxWidth: "100px" },
                      label: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" },
                    }}
                  />
                </CustomToolTipHost>
                {fibroidFilePath != null && fibroidFilePath !== "null" && (
                  <span
                    style={{
                      position: "absolute",
                      top: -4,
                      right: -4,
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      background: "#22c55e",
                      border: "1.5px solid #ffffff",
                      pointerEvents: "none",
                      zIndex: 1,
                    }}
                  />
                )}
              </div>
            )}

            {/* Desktop: Refresh stays inline alongside Fistulogram / Fibroid. */}
            {!isMobile && (
            <div className="refresh-button">
              <CustomToolTipHost content={t("button.refresh")} id="refresh-button-tooltip">
                <PrimaryButton
                  iconProps={{
                    iconName: "Refresh",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (!props.isChild) {
                      refreshReport();
                    }
                  }}
                  style={{ padding: "0px 5px" }}
                  text={t("button.refresh")}
                />
              </CustomToolTipHost>
              {/* <RefreshIcon />
            <span className="refresh-text">Refresh</span> */}
            </div>
            )}

            {/* Mobile: (3-dot) button that opens a dropdown containing the
                same Fistulogram / Fibroid / Refresh actions */}
            {isMobile && !props.isChild && (
            <div className="refresh-button" ref={mobileMoreMenuRef} style={{ position: "relative" }}>
              <CustomToolTipHost content="More actions" id="report-mobile-more-tooltip">
                <PrimaryButton
                  iconProps={{ iconName: "MoreVertical" }}
                  onClick={() => setShowMobileMoreMenu((prev) => !prev)}
                  style={{ padding: "0px 5px", minWidth: "40px" }}
                  ariaLabel="More actions"
                />
              </CustomToolTipHost>
              <ContextualMenu
                items={[
                  ...(showFistolugram ? [{
                    key: "fistulogram",
                    text: fistolugramFilePath != null && fistolugramFilePath !== "null"
                      ? "Fistulogram (edited)"
                      : "Fistulogram",
                    onClick: () => setOpenFistolugramModal(true),
                  }] : []),
                  ...(showFibroid ? [{
                    key: "fibroid",
                    text: fibroidFilePath != null && fibroidFilePath !== "null"
                      ? "Fibroid (edited)"
                      : "Fibroid",
                    onClick: () => setOpenFibroidModal(true),
                  }] : []),
                  {
                    key: "refresh",
                    text: t("button.refresh"),
                    iconProps: { iconName: "Refresh" },
                    onClick: () => { if (!props.isChild) refreshReport(); },
                  },
                ]}
                hidden={!showMobileMoreMenu}
                target={mobileMoreMenuRef}
                onItemClick={() => setShowMobileMoreMenu(false)}
                onDismiss={() => setShowMobileMoreMenu(false)}
                isBeakVisible={false}
              />
            </div>
            )}

          </div>
        </div>
      )}
      {isClientReportExist != null &&
        activeTab == 1 &&
        ((!props.isChild && patientReports.length > 0) || props.isChild) && (
          <div
            // className="modal-scroll-annotation"
            // style={{ height: props.isStudyList ? 'unset': height , overflow: "auto" }}
            className={`modal-scroll-annotation ${
              isWordFilePath ? "editor-blurred" : ""
            }`}
            style={{
              height: !isMobile
                ? enableLlmReport &&
                  isLLMAgentPresent(props.modality, studyDescription)
                  ? "100%"
                  : "calc(100% - 50px)"
                : "calc(100vh - 250px)",
              overflow: enableLlmReport &&
                isLLMAgentPresent(props.modality, studyDescription)
                  ? "hidden"
                  : "auto",
              // overflowY:
              //   enableLlmReport &&
              //   isLLMAgentPresent(props.modality, studyDescription)
              //     ? "hidden"
              //     : "auto",
            }}
          >
            {!props.isChild ? (
              <FroalaEditor
                tag="textarea"
                config={disableEditReport ? readOnlyConfig : (isMobile && props.readOnly ? emptyConfig: (isWordFilePath ? msWordConfig : config))}
                model={model}
                ref={editorRef}
                onModelChange={(val) => {
                  if (val === "") {
                    // Ignore transient empty value (Mac/Linux Chrome Froala bug)
                    return;
                  }
                  handleModelChange(val, false);
                  setDisableCopyButton(!hasText(val));
                }}
                // key={editReport.toString()}
                key={`${editReport.toString()}-${effectiveHeight}`}
                //style={{marginTop:"20px"}}
              />
            ) : (
              <FroalaEditor
                tag="textarea"
                config={emptyConfig}
                model={childModel}
                ref={editorRef}
                key={"empty"}
                //style={{marginTop:"20px"}}
              />
            )}
          </div>
        )}
      {isClientReportExist != null &&
        activeTab == 1 &&
        patientReports.length == 0 && (
          <div
            className="modal-scroll-annotation"
            style={
              !isMobile
                ? { height: "calc(100% - 50px)", overflow: "auto" }
                : { height: "calc(100vh - 250px)", overflow: "auto" }
            }
          >
            <FroalaEditor
              tag="textarea"
              //config={isWordFilePath ? msWordConfig : emptyConfig}
              config={
                isMobile && props.readOnly
                  ? emptyConfig
                  : isWordFilePath
                    ? msWordConfig
                    : emptyConfig
              }
              //model={model}
              //onModelChange={handleModelChange}
              key={`${editReport.toString()}-${effectiveHeight}`}
              //style={{marginTop:"20px"}}
            />
          </div>
        )}
      {isClientReportExist != null && activeTab == 2 && (
        <div
          className="modal-scroll-annotation"
          style={{
            height:
              enableLlmReport &&
              isLLMAgentPresent(props.modality, studyDescription)
                ? "100%"
                : "calc(100% - 50px)",
            overflow: "auto",
          }}
        >
          <FroalaEditor
            tag="textarea"
            //config={isWordFilePath ? msWordConfig : config}
            config={
              isMobile && props.readOnly
                ? emptyConfig
                : isWordFilePath
                  ? msWordConfig
                  : config
            }
            model={addendumModel}
            // key={editReport.toString()}
            key={`${editReport.toString()}-${effectiveHeight}`}
            ref={editorRef}
            // onModelChange={(val) => {
            //   if (val != addendumModel) {
            //     handleModelChange(val, true);
            //   }
            // }}
            onModelChange={(val) => {
              if (val != addendumModel) {
                handleModelChange(val, true);
                console.log("from last one called ");
                setDisableCopyButton(!hasText(val));
              }
            }}
          />
        </div>
      )}
      {!props.isChild && showCapturedImagesModal && (
        <ModalMain
          showModal={showCapturedImagesModal}
          // The captured-images popup uses @dnd-kit for drag-and-drop reordering. dnd-kit's
          // MouseSensor/TouchSensor attach their move/end listeners on `document`, but Fluent's Layer
          // (rendered by Modal) stops mouse/touch events from bubbling out of the layer by default,
          // so those listeners never fire and drag silently no-ops on both desktop and touch. Enabling
          // event bubbling on the Layer lets the events reach document so the sensors work. (Pointer
          // events are not filtered by the Layer, which is why the old PointerSensor worked.)
          layerProps={{ eventBubblingEnabled: true }}
          modalDetails={{
            header: (
              <ModalHeader
                updatedModal={true}
                heading={t("captured-images-tab.tab-label")}
                handleCancel={() => setShowCapturedImagesModal(false)}
              />
            ),
            body: (
              <div className="captured-images-modal-body-inner">
                <CapturedImagesTab onClose={() => setShowCapturedImagesModal(false)} />
              </div>
            ),
            // Single report template needs far less room — shrink the whole popup.
            // Multiple templates render side-by-side, so keep the larger size.
            ...(patientReports.length <= 1
              ? { width: "80vw", maxWidth: "1200px", height: "85vh" }
              : { width: "92vw", maxWidth: "1400px", height: "88vh" }),
          }}
        />
      )}
      </>)}
    </div>
  );
};

export default CustomEditor;
